import { IHinhThucThiActionTypes } from "../../action-types/tct/IHinhThucThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHinhThucThiReducer } from "../../reducer-model/tct/IHinhThucThiReducer";

const iniState: IHinhThucThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucThis: [],
  selectedIds: []
};
export const hinhThucThiReducer = (
  state: IHinhThucThiReducer = iniState,
  action: IHinhThucThiActionTypes
): IHinhThucThiReducer => {
  switch (action.type) {
    case "HINH_THUC_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HINH_THUC_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucThis: action.payload,
        selectedIds: []
      };
    case "HINH_THUC_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        hinhThucThiEditing: action.payload,
        isShowEditModal: true
      };
    case "HINH_THUC_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "HINH_THUC_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "HINH_THUC_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "HINH_THUC_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "HINH_THUC_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "HINH_THUC_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "HINH_THUC_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "HINH_THUC_THI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
